"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _Week = _interopRequireDefault(require("./Week"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MonthCalendar = function MonthCalendar(_ref) {
  var hidden = _ref.hidden,
      month = _ref.month,
      year = _ref.year,
      onSelectDate = _ref.onSelectDate,
      onHoverDate = _ref.onHoverDate,
      fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      hoverDate = _ref.hoverDate,
      isAnimating = _ref.isAnimating,
      startWeekDay = _ref.startWeekDay,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      monthFormat = _ref.monthFormat,
      weekDayFormat = _ref.weekDayFormat,
      isSingle = _ref.isSingle,
      highlightToday = _ref.highlightToday,
      singleCalendar = _ref.singleCalendar;

  function generateWeek() {
    var _getMonthInfo = (0, _helpers.getMonthInfo)(year, month, startWeekDay),
        totalWeek = _getMonthInfo.totalWeek,
        totalDay = _getMonthInfo.totalDay;

    return totalWeek.map(function (week, index) {
      return /*#__PURE__*/_react.default.createElement(_Week.default, {
        key: index,
        week: week,
        month: month,
        year: year,
        isFirst: index === 0,
        onSelectDate: onSelectDate,
        onHoverDate: onHoverDate,
        fromDate: fromDate,
        toDate: toDate,
        hoverDate: hoverDate,
        totalDay: totalDay,
        minDate: minDate,
        maxDate: maxDate,
        isSingle: isSingle,
        weekIndex: index,
        highlightToday: highlightToday
      });
    });
  }

  function generateWeekDay() {
    var arrWeekDay = (0, _helpers.getWeekDay)(startWeekDay, weekDayFormat);
    return arrWeekDay.map(function (day, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "weekday",
        key: index
      }, day);
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('month-calendar', {
      isAnimating: isAnimating,
      hidden: hidden,
      single: singleCalendar
    }),
    "data-month-index": month + 1
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "month-name"
  }, monthFormat ? (0, _dayjs.default)("".concat(year, "-").concat(month + 1, "-1")).format(monthFormat) : (0, _dayjs.default)("".concat(year, "-").concat(month + 1, "-1")).format('MMMM YYYY').split('+')[0]), /*#__PURE__*/_react.default.createElement("div", {
    className: "weekdays"
  }, generateWeekDay()), /*#__PURE__*/_react.default.createElement("div", {
    className: "week-container"
  }, generateWeek()));
};

MonthCalendar.propTypes = {
  month: _propTypes.default.number,
  year: _propTypes.default.number,
  onSelectDate: _propTypes.default.func,
  onHoverDate: _propTypes.default.func,
  fromDate: _propTypes.default.instanceOf(Date),
  toDate: _propTypes.default.instanceOf(Date),
  hoverDate: _propTypes.default.instanceOf(Date),
  hidden: _propTypes.default.bool,
  isAnimating: _propTypes.default.bool,
  startWeekDay: _propTypes.default.string,
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  monthFormat: _propTypes.default.string,
  isSingle: _propTypes.default.bool,
  highlightToday: _propTypes.default.bool,
  singleCalendar: _propTypes.default.bool
};
MonthCalendar.defaultProps = {
  month: null,
  year: null,
  onSelectDate: function onSelectDate() {},
  onHoverDate: function onHoverDate() {},
  fromDate: null,
  toDate: null,
  hoverDate: null,
  hidden: false,
  isAnimating: false,
  startWeekDay: null,
  minDate: null,
  maxDate: null,
  monthFormat: '',
  isSingle: false,
  highlightToday: false
};
var _default = MonthCalendar;
exports.default = _default;